"use strict";

export const tenantMap = {
  'au-legacy': {
    label: 'Australia',
    code: 'au'
  },
  au: {
    label: 'Australia',
    code: 'au'
  },
  nz: {
    label: 'New Zealand',
    code: 'nz'
  }
};